import { config } from '../../config';

export const API_BASE_URL = config.api.baseUrl;

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: {
    message: string;
    status: number;
  };
} 